/**
 * Force a reflow by reading `offsetHeight`. For example, this is needed to enforce style updates before animations
 * @param {HTMLElement} The outermost dom element affected by the reflow
 */
export default function forceReflow($el) {
    $el.offsetHeight; // eslint-disable-line no-unused-expressions
}



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/util/dom/force-reflow.js